module.exports = __webpack_public_path__ + "fontawesome-webfont.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/assets/fonts/fontawesome-webfont.svg?v=4.1.0
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.svg?v=4.1.0
// module chunks = styles